// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { rfqQuoteDetailsProposedDetailsGridStyles } from "@sc/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGrid";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsProposedDetailsGridStyles.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
        width: 100%;
    `,
};

rfqQuoteDetailsProposedDetailsGridStyles.footerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        margin-top: 20px;
        @media print {
            display: block;
            margin-top: 20px;
        }
    `,
};

rfqQuoteDetailsProposedDetailsGridStyles.headerWrapper = {
    css: css`
        display: flex;
        padding-bottom: 15px;
        ${xScreen("lte", "md")} {
            border-bottom: 1px solid ${getColor("common.border")};
        }
    `,
};

rfqQuoteDetailsProposedDetailsGridStyles.linesHeader = {
    total: {
        css: css`
            border-right: none;
        `,
    },
};
